<template>
    <section class="recent-wrapper">
        <div class="container">
            <div class="withdraw-sec">
                <AddBankAccount 
                    v-if="type == 'bank' "
                    ref="bankAccountRef"
                    :bankList="bankList"
                    :bankDetails="bankDetails"
                    :is2faEnabled="is2faEnabled"
                    @forget-withdraw-password="forgetWithdrawPassword"
                    />
                <AddUpiAccount
                   v-else
                    ref="upiAccountRef" 
                    :is2faEnabled="is2faEnabled"
                    :upiDetails="upiDetails"  
                    @forget-withdraw-password="forgetWithdrawPassword"
                    :paymentMethod="paymentMethod"
                    />

                <div class="back_btn_cl">
                    <button @click="validateAccount()" type="button" class="thm-but back_btn_link withdraw_btn_cl" id="account-successfully">{{$t('continue-to-add-account','Continue to add account')}}</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { mapGetters } from 'vuex';
import { check2FaStatus,addAccount,verifyTwoFa } from "@template/utils"
import AddBankAccount from '../components/AddBankAccount.vue';
import AddUpiAccount from '../components/AddUpiAccount.vue';
export default {
    name: 'WithdrawAccountDetails',
    setup() {
		return { v$: useVuelidate() }
	},
    components: {
		AddBankAccount,
        AddUpiAccount,
    },
    data(){
        return{
            bankList: null,
            s3Url: null,
            type: null,
            bankDetails:{
                method_id: null,
                account_holder_name: null,
                account_no: null,
                ifsc_code: null,
                withdrawal_password: null,
                otp:null,
            },
            upiDetails:{
                account_holder_name: null,
                upi_id: null,
                qr_code: null,
                withdrawal_password: null,
                otp:null
            },
            is2faEnabled:false
        }
    },
    computed:{
        ...mapGetters(['paymentMethod'])
    },
    created(){
       this.check2FaStatus()
    },
    mounted(){
        this.type = this.$route.params?.type
        let paymentId = Number(this.$route.params?.id)
        this.upiDetails.method_id = paymentId
    },
    methods:{
        check2FaStatus(){
           const response = check2FaStatus();
            if(response?.is2faEnabled){
                this.is2faEnabled = true
           }
        },
        forgetWithdrawPassword(){
            this.openWithdrawPasswordModal();
        },
        async verifyTwoFa(){
            const otp = this.type === 'bank' ? this.bankDetails?.otp : this.upiDetails?.otp
            const response = await verifyTwoFa(otp);
            if(!response?.error){
                this.addAccount()
            }else{
                if (this.type === 'bank') {
                    this.bankDetails.otp = ''
                } else {
                    this.upiDetails.otp = ''
                }
                 this.v$.$reset();
            }
        },
        async handleAddAccount(){
           if(this.is2faEnabled){
             this.verifyTwoFa()
           }else{
              this.addAccount()
           }
        },
        async addAccount(){
             let response = await addAccount(this.paymentMethod, this.type, this.bankDetails, this.upiDetails,this.is2faEnabled)
            if(response){
                this.$router.push({
                    name:'WithdrawDetails'
                })
            }
        },
        async validateAccount(){
            this.v$.$touch();
			if (this.v$.$error) {
				// this.$errorToast('Please fill the required fields');
				return;
			}
            if(this.type === 'upi' && !this.upiDetails.upi_id && this.upiDetails.qr_code == null){
                this.$errorToast('At least one field is required UPI ID or QR code.')
                return false;
            }
           this.handleAddAccount()
        },
    }
}
</script>